var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.61108H9.16667C6.02397 3.61108 4.45262 3.61108 3.47631 4.58739C2.5 5.56371 2.5 7.13506 2.5 10.2778V11.1111C2.5 14.2538 2.5 15.8251 3.47631 16.8014C4.45262 17.7778 6.02397 17.7778 9.16667 17.7778H10.8333C13.976 17.7778 15.5474 17.7778 16.5237 16.8014C17.5 15.8251 17.5 14.2538 17.5 11.1111V10.2777C17.5 7.13505 17.5 5.56371 16.5237 4.58739C15.5474 3.61108 13.976 3.61108 10.8333 3.61108Z",
    stroke: "#111827",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.77783H17.5",
    stroke: "#111827",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.77783V4.66672M13.75 2.77783V4.66672",
    stroke: "#111827",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d970915954984fa9bfd2c3386465afb4.svg";
export { ForwardRef as ReactComponent };